export default "/images/vendor/flag-icon-css/flags/4x3/sd.svg?090d0e106e0c7fd28b239852af2c91e1";